import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import ConstructionIcon from '@mui/icons-material/Construction';

function FeatureBox({ title, description, imageSrc, titleColor = "text-gray-800", titleIcon, isReady, link }) {
    const Wrapper = isReady && link ? 'a' : 'div';
    return (
        <Wrapper
            {...(isReady && link ? { href: link } : {})}
            className={`
                bg-white max-w-md mr-auto rounded-xl shadow-md p-6 text-sm transition 
                ${isReady ? "hover:shadow-xl hover:-translate-y-1 cursor-pointer" : "opacity-70 cursor-default"}
                block
            `}
            >
            <div className={`flex items-center gap-2 mb-2 ${titleColor}`}>
                {titleIcon && <span className="text-base">{titleIcon}</span>}
                <h3 className="text-base font-semibold">{title}</h3>
            </div>
            {description && <p className="text-gray-600 mb-4 text-sm">{description}</p>}
            {imageSrc && (
                <img
                src={imageSrc}
                alt={`${title} 이미지`}
                className="w-full h-auto rounded-md border"
                />
            )}
        </Wrapper>
    );
  }
  
  export default function MainPage() {
    return (
      <div className="min-h-screen flex flex-col bg-white">
        {/* 헤더 */}
        <header className="p-6 flex justify-between items-center">
            <img src="/logo/main_log.png" alt="LogisValley BnF 로고" className="h-10" />
          {/* <h1 className="text-2xl font-bold">LogisValley BnF</h1> */}
          {/* <a href="/dashboard" className="bg-black text-white px-4 py-2 rounded-xl">
            대시보드 바로가기
          </a> */}
        </header>
  
        {/* 본문 */}
        <main className="flex-grow">
          {/* Hero Section */}
          <section className="relative h-[500px] flex items-center justify-center text-black overflow-hidden">
            {/* 배경 이미지 */}
            <img
                src="/logo/main_hero.png"
                alt="데이터 기반 인사이트 마케팅 배경"
                className="absolute inset-0 w-full h-full object-cover opacity-30"
            />

            {/* 텍스트 (위에 겹쳐짐) */}
            <div className="relative z-10 text-center px-4">
                <h2 className="text-4xl font-bold mb-4">데이터 기반 인사이트 마케팅</h2>
                <p className="text-lg">모든 지표를 한눈에 확인하세요</p>
            </div>
          </section>
  
          {/* 기능 박스 */}
          <section className="grid md:grid-cols-5 gap-8 p-12">
            <FeatureBox 
                title="E-commerce Product Ranking" 
                descripttion="E-commerce Product Ranking Insights" 
                imageSrc="/menu/cosmetic-rank-image.png"
                titleIcon={<StorefrontOutlinedIcon fontSize="small" />}
                isReady={true}
                link="/dashboard/real-category-rank-trend"
            />
            <FeatureBox 
                title="Coming Soon..." 
                titleColor="text-gray-400"
                descripttion="Coming Soon..." 
                imageSrc="/menu/menu_sample.png"
                titleIcon={<ConstructionIcon fontSize="small" />}
                isReady={false}
            />
            <FeatureBox 
                title="Coming Soon..." 
                titleColor="text-gray-400"
                descripttion="Coming Soon..." 
                imageSrc="/menu/menu_sample.png"
                titleIcon={<ConstructionIcon fontSize="small" />}
                isReady={false}
            />
            <FeatureBox 
                title="Coming Soon..." 
                titleColor="text-gray-400"
                descripttion="Coming Soon..." 
                imageSrc="/menu/menu_sample.png"
                titleIcon={<ConstructionIcon fontSize="small" />}
                isReady={false}
            />
            <FeatureBox 
                title="Coming Soon..." 
                titleColor="text-gray-400"
                descripttion="Coming Soon..." 
                imageSrc="/menu/menu_sample.png"
                titleIcon={<StorefrontOutlinedIcon fontSize="small" />}
                isReady={false}
            />
            {/* <FeatureBox title="경쟁사 비교" />
            <FeatureBox title="광고 캠페인 효과 측정" /> */}
          </section>
        </main>
  
        {/* 푸터 */}
        <footer className="bg-gray-900 text-white p-6 text-sm text-center">
          &copy; 2025 LogisValley. All rights reserved.
        </footer>
      </div>
    );
  }